module.exports = __webpack_public_path__ + "img/icon-pinglun.8ba3a790.svg";